import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/close.png'


const _withScopeId = n => (_pushScopeId("data-v-78f8ad42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-image" }
const _hoisted_2 = { class: "box-images" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "multiple-images" }
const _hoisted_8 = ["src"]

import Controller from './controller.vue';
  import { reactive, inject, computed, watchEffect, ref } from 'vue';
  import { FormItem } from '@/types/form';
  import { AdminSdk } from './admin-sdk';

  interface IFormProps {
    images?: string[]
  }
  interface IProps {
    props: IFormProps,
    modelValue?: boolean;
  }
  interface IEmits {
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IFormProps): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    props: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IFormProps): void;
  }), expose: any, slots: any, attrs: any }) {

const componentProps = __props as {
    props: IFormProps,
    modelValue?: boolean;
  }

  
  
  const images = ref<string[]>([]);
  const editorMode = inject('editorMode');
  const adminSdk = inject<AdminSdk>('adminSdk');

  const form = reactive<IFormProps>({});
  const formList = computed<FormItem[]>(() => {
    return [];
  });

  const handleChange = (form: IFormProps) => {
    emits('change', { ...form, images: images.value });
  };

  watchEffect(() => {
    Object.assign(form, componentProps.props);
  });

  const handleUpload = async () => {
    if (adminSdk) {
      const { data } = await adminSdk.upload({
        limit: 5,
        accept: 'images/*'
      });
      // blob_url
      const imageUrls = data.map((item: any) => item.blob_url);
      images.value.push(...imageUrls);
    }
  };

  const handleDeleteImage = (index: number) => {
    images.value.splice(index, 1);
  };

  watchEffect(() => {
    images.value = [...(componentProps.props.images || [])];
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(editorMode))
      ? (_openBlock(), _createBlock(Controller, {
          key: 0,
          title: "Image",
          visible: __props.modelValue,
          "form-list": _unref(formList),
          form: _unref(form),
          "onUpdate:visible": _cache[0] || (_cache[0] = visible => emits('update:modelValue', visible)),
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "item"
                }, [
                  _createElementVNode("img", {
                    class: "image",
                    src: image
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", {
                    class: "btn-close",
                    onClick: ($event: any) => (handleDeleteImage(index))
                  }, _hoisted_6, 8, _hoisted_4)
                ]))
              }), 128))
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: handleUpload
            }, " Upload ")
          ]),
          _: 1
        }, 8, ["visible", "form-list", "form"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.props.images, (image, index) => {
        return (_openBlock(), _createElementBlock("img", {
          key: index,
          src: image
        }, null, 8, _hoisted_8))
      }), 128))
    ])
  ]))
}
}

})